var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 13.999C28 21.731 21.732 27.999 14 27.999C6.26803 27.999 0 21.731 0 13.999C0 6.26706 6.26803 -0.000976562 14 -0.000976562C21.732 -0.000976562 28 6.26706 28 13.999ZM7.56442 9.67238C7.71413 9.80594 7.79059 10.002 7.77032 10.2005V17.3452C7.81473 17.6029 7.73266 17.8662 7.54916 18.0544L5.8335 20.1141V20.3857H10.6984V20.1141L8.98272 18.0544C8.79795 17.8665 8.71077 17.605 8.74634 17.3452V11.1662L13.0165 20.3857H13.5122L17.1799 11.1662V18.5146C17.1799 18.7108 17.1799 18.7485 17.0503 18.8767L15.7311 20.1442V20.4159H22.1363V20.1442L20.8629 18.9069C20.7505 18.8222 20.6947 18.6828 20.718 18.5448V9.45357C20.6947 9.31561 20.7505 9.17622 20.8629 9.09142L22.1668 7.85414V7.58252H17.6527L14.4348 15.5269L10.7747 7.58252H6.03938V7.85414L7.56442 9.67238Z",
    fill: "url(#paint0_linear_5143_5404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5143_5404",
    x1: 3.5,
    y1: 2.52778,
    x2: 26.8333,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E470AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#7230FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.ede4b5088b5e8152cb4ca5e90079eab6.svg";
export { ForwardRef as ReactComponent };